export const tryCatch = <R, T extends () => R>(
  fn: T,
  catchFn: <E extends Error>(e: E) => void,
  finallyFn?: () => void,
): R | undefined => {
  try {
    const result = fn()
    if (result instanceof Promise) {
      return result
        .catch(catchFn)
        .finally(finallyFn) as R
    }
  } catch (e) {
    if (e instanceof Error) {
      catchFn(e)
    } else {
      throw e
    }
  } finally {
    finallyFn?.()
  }
}

export const tryCatchAsync = async <R, T extends () => Promise<R>>(
  fn: T,
  catchFn: <E extends Error>(e: E) => void,
  finallyFn?: () => void,
): Promise<R | undefined> => {
  try {
    const result = await fn()
    return result
  } catch (e) {
    if (e instanceof Error) {
      catchFn(e)
    } else {
      throw e
    }
  } finally {
    finallyFn?.()
  }
}
